export default "__VITE_ASSET__P5i1lKs7__"